import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/casos-reales-retail")({
  beforeLoad: () => {
    throw redirect({ to: "/casos-reales", statusCode: 301 });
  },
});
